/* FORMÉ — theme.js
   No dependencies. Progressive enhancement only: every interaction has a
   no-JS fallback (forms POST, links navigate, accordions render open). */
(function () {
  'use strict';

  var money = function (cents) {
    var fmt = document.documentElement.getAttribute('data-money-format') || 'AED {{amount}}';
    var amount = (cents / 100).toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
    return fmt.replace(/\{\{\s*amount\s*\}\}/, amount);
  };

  var on = function (root, evt, sel, fn) {
    root.addEventListener(evt, function (e) {
      var el = e.target.closest(sel);
      if (el && root.contains(el)) fn(e, el);
    });
  };

  /* ---------- header: overlay → solid on scroll ---------- */
  function initHeader() {
    var header = document.querySelector('[data-header]');
    if (!header) return;

    if (header.classList.contains('header--overlay')) {
      var onScroll = function () {
        header.classList.toggle('is-scrolled', window.scrollY > 40);
      };
      onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });
    }

    /* mega menu */
    var closeAll = function () {
      document.querySelectorAll('[data-mega].is-open').forEach(function (m) {
        m.classList.remove('is-open');
        var t = document.querySelector('[data-mega-trigger="' + m.dataset.mega + '"]');
        if (t) t.setAttribute('aria-expanded', 'false');
      });
    };

    on(header, 'click', '[data-mega-trigger]', function (e, el) {
      var id = el.dataset.megaTrigger;
      var panel = document.querySelector('[data-mega="' + id + '"]');
      if (!panel) return;
      e.preventDefault();
      var isOpen = panel.classList.contains('is-open');
      closeAll();
      if (!isOpen) {
        panel.classList.add('is-open');
        el.setAttribute('aria-expanded', 'true');
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll();
    });
    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-mega]') && !e.target.closest('[data-mega-trigger]')) closeAll();
    });
  }

  /* ---------- mobile nav ---------- */
  function initMobileNav() {
    var nav = document.querySelector('[data-mobile-nav]');
    if (!nav) return;
    var open = function () { nav.classList.add('is-open'); document.body.style.overflow = 'hidden'; };
    var close = function () { nav.classList.remove('is-open'); document.body.style.overflow = ''; };

    document.querySelectorAll('[data-mobile-nav-open]').forEach(function (b) { b.addEventListener('click', open); });
    document.querySelectorAll('[data-mobile-nav-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

    on(nav, 'click', '[data-mobile-sub-toggle]', function (e, el) {
      e.preventDefault();
      var sub = el.nextElementSibling;
      if (!sub) return;
      var open = sub.hasAttribute('hidden');
      if (open) sub.removeAttribute('hidden'); else sub.setAttribute('hidden', '');
      el.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* ---------- accordions ---------- */
  function initAccordions() {
    on(document, 'click', '.accordion__trigger', function (e, el) {
      var panel = document.getElementById(el.getAttribute('aria-controls'));
      if (!panel) return;
      var open = el.getAttribute('aria-expanded') === 'true';
      el.setAttribute('aria-expanded', open ? 'false' : 'true');
      panel.classList.toggle('is-open', !open);
    });
  }

  /* ---------- collection: density + filter toggle ---------- */
  function initCollection() {
    /* The view-density switcher was removed on the client's instruction — a
       three-piece range does not need a choice of grid widths. The grid still
       carries data-density so the CSS has a column count to read; nothing
       changes it at runtime any more. */

    on(document, 'click', '[data-filter-toggle]', function (e, el) {
      var panel = document.querySelector('[data-filters]');
      if (!panel) return;
      var open = panel.classList.toggle('is-open');
      el.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* ---------- PDP: variants ---------- */
  function initProduct() {
    document.querySelectorAll('[data-product-form]').forEach(function (form) {
      var root = form.closest('[data-product-root]') || document;
      var dataEl = root.querySelector('[data-product-json]');
      if (!dataEl) return;

      var product;
      try { product = JSON.parse(dataEl.textContent); } catch (err) { return; }

      var idInput = form.querySelector('[data-variant-id]');
      var notesRoot = form.closest('[data-option-notes]') || root.querySelector('[data-option-notes]') || document.body;
      var priceEl = root.querySelector('[data-price]');
      var stockEl = root.querySelector('[data-stock]');
      var submit = form.querySelector('[data-submit]');
      var submitPrice = form.querySelector('[data-submit-price]');

      var findVariant = function () {
        var chosen = [];
        form.querySelectorAll('[data-option-index]').forEach(function (input) {
          if (input.checked || input.tagName === 'SELECT') {
            chosen[parseInt(input.dataset.optionIndex, 10)] = input.value;
          }
        });
        return product.variants.find(function (v) {
          return v.options.every(function (o, i) { return chosen[i] === undefined || o === chosen[i]; });
        });
      };

      var update = function () {
        var v = findVariant();
        if (!v) return;
        if (idInput) idInput.value = v.id;

        if (priceEl) priceEl.innerHTML = money(v.price);
        if (submitPrice) submitPrice.textContent = money(v.price);

        if (stockEl) {
          stockEl.innerHTML = v.available
            ? '<span class="buycard__dot"></span> In stock'
            : '<span class="buycard__dot buycard__dot--out"></span> Made to order';
        }
        if (submit) {
          submit.disabled = false;
          var label = submit.querySelector('[data-submit-label]');
          if (label) label.textContent = v.available ? 'Add to cart' : 'Enquire';
        }

        /* selected option name readouts */
        root.querySelectorAll('[data-option-value-for]').forEach(function (el) {
          var i = parseInt(el.dataset.optionValueFor, 10);
          el.textContent = v.options[i] || '';
        });

        /* Attributes fixed by an option value rather than chosen — the
           Notebook's ruling travels with its colour. "Value|Note;;Value|Note" */
        root.querySelectorAll('[data-option-note-for]').forEach(function (el) {
          var i = parseInt(el.dataset.optionNoteFor, 10);
          var value = v.options[i] || '';
          var note = '';
          (notesRoot.dataset.optionNotes || '').split(';;').forEach(function (row) {
            var pair = row.split('|');
            if (pair.length > 1 && pair[0] === value) note = pair[1];
          });
          el.textContent = note ? ' — ' + note.toLowerCase() : '';
        });

        /* Gallery grouping by alt tag — the standard Shopify convention for
           colourways that share one product. Falls back to showing everything
           when no frame mentions the selected value. */
        var frames = root.querySelectorAll('[data-gallery-frame]');
        if (frames.length) {
          var altOf = function (f) { return (((f.querySelector('img') || {}).alt) || '').toLowerCase(); };

          /* Find the option axis the photography is grouped by: the first one
             whose values appear in some — but not all — alt tags. */
          var axis = -1;
          for (var i = 0; i < v.options.length && axis === -1; i++) {
            var value = (v.options[i] || '').toLowerCase();
            if (!value) continue;
            var hits = 0;
            frames.forEach(function (f) { if (altOf(f).indexOf(value) > -1) hits++; });
            if (hits > 0 && hits < frames.length) axis = i;
          }

          if (axis > -1) {
            var selected = (v.options[axis] || '').toLowerCase();
            var others = [];
            product.variants.forEach(function (pv) {
              var val = (pv.options[axis] || '').toLowerCase();
              if (val && val !== selected && others.indexOf(val) === -1) others.push(val);
            });

            frames.forEach(function (f) {
              var alt = altOf(f);
              /* Hide only frames that belong to a *different* colourway. Shots
                 that name no colourway (packaging, certificate) always show. */
              var belongsElsewhere = others.some(function (o) { return alt.indexOf(o) > -1; })
                && alt.indexOf(selected) === -1;
              f.hidden = belongsElsewhere;
              var img = f.querySelector('img');
              if (!belongsElsewhere && img && img.loading === 'lazy') img.loading = 'eager';
            });
          }
        }

        /* keep the URL shareable */
        if (window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url);
        }
      };

      form.addEventListener('change', update);
      update();

      /* AJAX add to cart */
      form.addEventListener('submit', function (e) {
        if (!window.fetch || form.dataset.noAjax === 'true') return;
        e.preventDefault();
        var btn = form.querySelector('[data-submit]');
        var label = btn && btn.querySelector('[data-submit-label]');
        var prev = label ? label.textContent : '';
        if (label) label.textContent = 'Adding…';
        if (btn) btn.disabled = true;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{ id: idInput.value, quantity: 1, properties: collectProperties(form) }]
          })
        })
          .then(function (r) {
            /* A rejected add still resolves the promise — Shopify answers 422
               for sold out and 5xx when it is having a moment. Without this
               check both read as success: the drawer opens, empty, and the
               shopper is told nothing. */
            return r.json().catch(function () { return {}; }).then(function (data) {
              if (!r.ok) {
                var e = new Error(data.description || data.message ||
                  (data.errors && JSON.stringify(data.errors)) || ('HTTP ' + r.status));
                e.status = r.status;
                throw e;
              }
              return data;
            });
          })
          .then(function () { return refreshCart(); })
          .then(function () { openCart(); })
          .catch(function (err) {
            /* 5xx is worth one native retry — the browser posts the form and
               Shopify renders its own cart page. A 4xx is the shopper's answer,
               not a transport problem, so say it instead of reloading. */
            if (!err.status || err.status >= 500) {
              form.dataset.noAjax = 'true';
              form.submit();
              return;
            }
            if (label) label.textContent = 'Unavailable';
            var note = form.querySelector('[data-add-error]');
            if (note) { note.textContent = err.message; note.hidden = false; }
            setTimeout(function () {
              if (label) label.textContent = prev;
              if (note) note.hidden = true;
            }, 4000);
          })
          .finally(function () {
            if (btn) btn.disabled = false;
            if (label && label.textContent === 'Adding…') label.textContent = prev;
          });
      });
    });

    function collectProperties(form) {
      var props = {};
      form.querySelectorAll('[name^="properties["]').forEach(function (input) {
        if (input.type === 'checkbox' && !input.checked) return;
        if (!input.value) return;
        var key = input.name.replace(/^properties\[|\]$/g, '');
        props[key] = input.value;
      });
      return props;
    }

    /* sticky mini buy bar */
    var sticky = document.querySelector('[data-stickybuy]');
    var anchor = document.querySelector('[data-stickybuy-anchor]');
    if (sticky && anchor && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        sticky.classList.toggle('is-visible', !entries[0].isIntersecting);
      }, { rootMargin: '-120px 0px 0px 0px' }).observe(anchor);
    }

    on(document, 'click', '[data-sticky-add]', function (e) {
      e.preventDefault();
      var submit = document.querySelector('[data-submit]');
      if (submit) submit.click();
    });
  }

  /* ---------- cart drawer ---------- */
  function openCart() {
    var d = document.querySelector('[data-cart-drawer]');
    var o = document.querySelector('[data-cart-overlay]');
    if (!d) return;
    d.classList.add('is-open');
    if (o) o.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    var close = d.querySelector('[data-cart-close]');
    if (close) close.focus();
  }
  function closeCart() {
    var d = document.querySelector('[data-cart-drawer]');
    var o = document.querySelector('[data-cart-overlay]');
    if (d) d.classList.remove('is-open');
    if (o) o.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  /* Two requests, because they answer different questions and fail
     independently. /cart.js is the count and always works; the section render
     is the drawer's markup. Reading the count out of the drawer HTML alone —
     which this used to do — meant a failed section render silently froze the
     header at whatever it last said. */
  function refreshCart() {
    if (!window.fetch) return Promise.resolve();

    var counts = fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart) return;
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = '(' + cart.item_count + ')';
        });
      })
      .catch(function () {});

    var markup = fetch('/?section_id=cart-drawer')
      .then(function (r) {
        if (!r.ok) throw new Error('section_id=cart-drawer returned ' + r.status);
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var next = doc.querySelector('[data-cart-drawer-contents]');
        var cur = document.querySelector('[data-cart-drawer-contents]');
        if (next && cur) cur.innerHTML = next.innerHTML;
      })
      .catch(function (e) {
        /* Do not swallow this. A 404 here means cart-drawer is not a section
           in this theme, and the only symptom is a drawer that opens empty —
           which reads as "add to cart is broken" and sends you looking in
           entirely the wrong place. */
        if (window.console) console.error('[forme] cart drawer refresh failed:', e.message);
      });

    return Promise.all([counts, markup]);
  }

  function initCart() {
    on(document, 'click', '[data-cart-open]', function (e) { e.preventDefault(); openCart(); });
    on(document, 'click', '[data-cart-close], [data-cart-overlay]', function (e) { e.preventDefault(); closeCart(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCart(); });

    on(document, 'click', '[data-qty-change]', function (e, el) {
      e.preventDefault();
      var input = el.parentElement.querySelector('input');
      if (!input) return;
      var next = Math.max(0, parseInt(input.value || '0', 10) + parseInt(el.dataset.qtyChange, 10));
      input.value = next;
      changeLine(input.dataset.lineKey, next);
    });

    on(document, 'click', '[data-line-remove]', function (e, el) {
      e.preventDefault();
      changeLine(el.dataset.lineRemove, 0);
    });

    function changeLine(key, quantity) {
      if (!key || !window.fetch) return;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
        .then(function () { return refreshCart(); })
        .then(function () { if (document.body.classList.contains('template-cart')) window.location.reload(); })
        .catch(function () { window.location.reload(); });
    }
  }

  /* ---------- reveal on scroll ---------- */
  function initReveal() {
    var els = document.querySelectorAll('.reveal');
    if (!els.length || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function init() {
    initHeader();
    initMobileNav();
    initAccordions();
    initCollection();
    initProduct();
    initCart();
    initReveal();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
